import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import EnergyHubClubVisitList from '../detail/energy-hub-club-visit-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Hub Run Requests">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/energy-hubs">Energy Hubs</Breadcrumb.Item>
            <Breadcrumb.Item active>Hub Run Requests</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <EnergyHubClubVisitList />
    </Panel>
  );
};

export default Page;
